var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFormHeaderText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 164,
    height: 29.722,
    viewBox: "0 0 164 29.722",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "form-header-text",
    transform: "translate(-85 -88.697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(85.249 88.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M88.155,562.64h3.706l5.905,13.971H93.644l-1.01-2.477H87.283l-.99,2.477H82.25Zm3.369,8.521-1.545-3.943-1.566,3.943Z",
    transform: "translate(-82.25 -562.64)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M126.679,562.9h3.845v10.5h6.718v3.369H126.679Z",
    transform: "translate(-109.816 -562.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M157.691,578.773h6.5v3.31h-6.5Z",
    transform: "translate(-129.057 -572.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M183.123,562.64h3.706l5.9,13.971h-4.122l-1.011-2.477h-5.351l-.99,2.477h-4.043Zm3.369,8.521-1.546-3.943-1.566,3.943Z",
    transform: "translate(-141.173 -562.64)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M221.647,562.9h4.062l3.31,5.37,3.309-5.37h4.062v13.872h-3.824v-7.966l-3.537,5.43h-.08l-3.517-5.39v7.927h-3.785Z",
    transform: "translate(-168.738 -562.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M269.948,562.64h3.706l5.905,13.971h-4.122l-1.011-2.477h-5.351l-.99,2.477h-4.043Zm3.369,8.521-1.546-3.943-1.566,3.943Z",
    transform: "translate(-195.043 -562.64)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M308.472,562.9h3.595l5.719,7.332V562.9h3.785v13.872h-3.376l-5.938-7.61v7.61h-3.785Z",
    transform: "translate(-222.609 -562.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M363.917,562.9h11.1v3.369h-7.253v2.338h6.559v3.21h-6.559v4.954h-3.845Z",
    transform: "translate(-257.009 -562.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M403.7,577.031a8.834,8.834,0,0,1-2.675-.377A5.183,5.183,0,0,1,399,575.5a5.113,5.113,0,0,1-1.278-1.981,8.09,8.09,0,0,1-.446-2.824V562.9H401.2v7.709a3.137,3.137,0,0,0,.688,2.229,2.429,2.429,0,0,0,1.848.723,2.486,2.486,0,0,0,1.848-.694,2.961,2.961,0,0,0,.689-2.16V562.9H410.2v7.689a8.134,8.134,0,0,1-.466,2.9,5.027,5.027,0,0,1-3.348,3.16A8.935,8.935,0,0,1,403.7,577.031Z",
    transform: "translate(-277.708 -562.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M437.323,562.9h3.6l5.719,7.332V562.9h3.785v13.872h-3.376l-5.938-7.61v7.61h-3.785Z",
    transform: "translate(-302.554 -562.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M478.307,562.9h5.351a10.109,10.109,0,0,1,3.32.5,7.02,7.02,0,0,1,2.457,1.417,6.046,6.046,0,0,1,1.525,2.17,7.111,7.111,0,0,1,.526,2.764v.04a7.144,7.144,0,0,1-.536,2.784,6.244,6.244,0,0,1-1.546,2.209,7.132,7.132,0,0,1-2.487,1.456,9.9,9.9,0,0,1-3.339.526h-5.272Zm5.416,10.463a4.1,4.1,0,0,0,2.784-.912,3.244,3.244,0,0,0,1.055-2.6v-.04a3.252,3.252,0,0,0-1.055-2.586,4.075,4.075,0,0,0-2.784-.922h-1.571v7.055Z",
    transform: "translate(-327.982 -562.803)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(85 110.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M81.595,628.319h1.291v-3.066h3.809v-1.219H82.886v-2.016h4.261v-1.23H81.595Z",
    transform: "translate(-81.595 -620.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M101.59,620.468a3.826,3.826,0,0,0-3.847,3.887v.02a3.762,3.762,0,0,0,3.826,3.866,3.83,3.83,0,0,0,3.846-3.907A3.761,3.761,0,0,0,101.59,620.468Zm2.5,3.907a2.516,2.516,0,0,1-2.5,2.636,2.542,2.542,0,0,1-2.526-2.677,2.518,2.518,0,1,1,5.03.021Z",
    transform: "translate(-91.614 -620.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M127.128,623.126a2.182,2.182,0,0,0-.616-1.562,3.029,3.029,0,0,0-2.175-.776h-3.273v7.531h1.291v-2.734h1.637l2.04,2.734h1.6l-2.232-2.97A2.233,2.233,0,0,0,127.128,623.126Zm-4.773,1.249v-2.357h1.922c.986,0,1.55.415,1.55,1.158s-.612,1.2-1.56,1.2Z",
    transform: "translate(-106.083 -620.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M146.821,622.018h2.362v6.3h1.3v-6.3h2.361v-1.23h-6.024Z",
    transform: "translate(-122.064 -620.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M170.152,623.913h-3.563v-3.125H165.3v7.531h1.291v-3.166h3.563v3.166h1.29v-7.531h-1.29Z",
    transform: "translate(-133.528 -620.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M186.708,625.133h3.839v-1.22h-3.839v-1.905H191v-1.219h-5.581v7.531h5.632V627.1h-4.341Z",
    transform: "translate(-146.012 -620.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M211.1,628.319h1.291v-3.066H216.2v-1.219h-3.809v-2.016h4.26v-1.23H211.1Z",
    transform: "translate(-161.943 -620.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M233.236,625.126c0,1.336-.665,2.072-1.872,2.072-1.227,0-1.9-.754-1.9-2.124v-4.287h-1.29v4.338a3.005,3.005,0,0,0,3.172,3.3c1.993,0,3.182-1.258,3.182-3.362v-4.278h-1.29Z",
    transform: "translate(-172.538 -620.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M247.229,622.018h2.361v6.3h1.3v-6.3h2.362v-1.23h-6.024Z",
    transform: "translate(-184.362 -620.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M270.48,625.126c0,1.336-.664,2.072-1.872,2.072s-1.9-.774-1.9-2.124v-4.287h-1.291v4.338a3.005,3.005,0,0,0,3.173,3.3c1.993,0,3.182-1.258,3.182-3.362v-4.278h-1.29Z",
    transform: "translate(-195.645 -620.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M291.863,623.126a2.183,2.183,0,0,0-.616-1.562,3.033,3.033,0,0,0-2.175-.776H285.8v7.531h1.29v-2.734h1.637l2.04,2.734h1.6l-2.233-2.97A2.233,2.233,0,0,0,291.863,623.126Zm-4.774,1.249v-2.357h1.923c.986,0,1.55.415,1.55,1.158s-.612,1.2-1.56,1.2Z",
    transform: "translate(-208.293 -620.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M306.229,625.133h3.838v-1.22h-3.838v-1.905h4.291v-1.219h-5.582v7.531h5.632V627.1h-4.34Z",
    transform: "translate(-220.167 -620.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M333.643,620.468a3.825,3.825,0,0,0-3.846,3.887v.02a3.761,3.761,0,0,0,3.825,3.866,3.83,3.83,0,0,0,3.846-3.907A3.761,3.761,0,0,0,333.643,620.468Zm2.5,3.907a2.516,2.516,0,0,1-2.5,2.636,2.542,2.542,0,0,1-2.525-2.677,2.518,2.518,0,1,1,5.03.021Z",
    transform: "translate(-235.591 -620.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M353.118,628.319h1.29v-3.066h3.809v-1.219h-3.809v-2.016h4.261v-1.23h-5.551Z",
    transform: "translate(-250.06 -620.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M381.45,620.468a3.825,3.825,0,0,0-3.846,3.887v.02a3.761,3.761,0,0,0,3.825,3.866,3.831,3.831,0,0,0,3.846-3.907A3.762,3.762,0,0,0,381.45,620.468Zm2.5,3.907a2.516,2.516,0,0,1-2.5,2.636,2.542,2.542,0,0,1-2.526-2.677,2.518,2.518,0,1,1,5.03.021Z",
    transform: "translate(-265.253 -620.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M406.991,623.126a2.182,2.182,0,0,0-.616-1.562,3.032,3.032,0,0,0-2.175-.776h-3.273v7.531h1.29v-2.734h1.638l2.039,2.734h1.6l-2.233-2.97A2.234,2.234,0,0,0,406.991,623.126Zm-4.774,1.249v-2.357h1.923c.986,0,1.551.415,1.551,1.158s-.613,1.2-1.561,1.2Z",
    transform: "translate(-279.723 -620.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M422.945,620.788h-2.882v7.531h1.291v-2.483h1.459c1.8,0,3.012-1.024,3.012-2.57C425.826,621.761,424.695,620.788,422.945,620.788Zm-.1,3.828h-1.489v-2.6h1.53c.613,0,1.64.166,1.64,1.3C424.525,624.106,423.865,624.616,422.844,624.616Z",
    transform: "translate(-291.596 -620.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M442.6,623.913h-3.563v-3.125h-1.29v7.531h1.29v-3.166H442.6v3.166h1.291v-7.531H442.6Z",
    transform: "translate(-302.569 -620.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M459.348,620.655l-3.43,7.582h1.36l.834-1.859h3.506l.825,1.859h1.4l-3.43-7.582Zm-.7,4.5,1.223-2.721,1.216,2.721Z",
    transform: "translate(-313.842 -620.584)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M483.955,625.956l-4.063-5.168h-1.113v7.531h1.271v-5.3l4.173,5.3h1v-7.531h-1.27Z",
    transform: "translate(-328.026 -620.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M501.6,623.763c-1.587-.34-1.713-.695-1.713-1.144,0-.522.513-.887,1.248-.887a2.843,2.843,0,0,1,1.873.707l.2.164.764-1.013-.188-.151a3.941,3.941,0,0,0-2.627-.918,2.312,2.312,0,0,0-2.56,2.188c0,1.508,1.229,1.984,2.558,2.272,1.513.32,1.633.67,1.633,1.115,0,.566-.531.948-1.319.948a3.1,3.1,0,0,1-2.245-.931l-.191-.173-.813.964.18.161a4.339,4.339,0,0,0,3.039,1.188,2.364,2.364,0,0,0,2.65-2.258C504.088,624.5,502.76,624.015,501.6,623.763Z",
    transform: "translate(-340.088 -620.502)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormHeaderText);
export default __webpack_public_path__ + "static/media/form-header-text.75df23b982529c19f064d1cdf594bdd8.svg";
export { ForwardRef as ReactComponent };